import { DefaultListProps } from "./types";
import {
  getAlignItemsClassNames,
  getJustifyContentClassNames,
} from "utilities/commonPropTypes/flex";
import { getColSizeClassNames } from "utilities/commonPropTypes/colSize";
import React from "react";
import classNames from "classnames";

const DefaultList = ({
  alignItems,
  children,
  xsColSize,
  smColSize,
  mdColSize,
  lgColSize,
  xlColSize,
  customClass,
  justifyContent,
}: DefaultListProps) => {
  const rowClasses = classNames(
    "row",
    customClass,
    getJustifyContentClassNames({
      justifyContent,
    }),
    getAlignItemsClassNames({
      alignItems,
    }),
  );
  const colClasses = classNames(
    "List__item",
    getColSizeClassNames({
      xsColSize,
      smColSize,
      mdColSize,
      lgColSize,
      xlColSize,
    }),
  );
  return (
    <div className="container-fluid">
      <div data-testid="listChildren" className={rowClasses}>
        {React.Children.map(children, (child) => {
          return <div className={colClasses}>{child}</div>;
        })}
      </div>
    </div>
  );
};

export default DefaultList;
